import { ChangeDetectionStrategy, Component, inject, input, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TeamService } from '@artemis-software/wr-api';
import { Tracked } from '@/utils/signals/tracked';
import { loader } from '@/utils/signals/loader';
import { asyncComputed } from '@/utils/signals/asyncComputed';

@Component({
  standalone: false,
  selector: 'wr-team-popover',
  templateUrl: './team-popover.component.html',
  styleUrls: ['./team-popover.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TeamPopoverComponent {
  readonly router = inject(Router);
  readonly teamService = inject(TeamService);

  readonly teamId = input<string>();

  @Input()
  @Tracked()
  disableLink = false;

  loading = loader();

  readonly team = asyncComputed(() => {
    const teamId = this.teamId();
    if (!teamId) {
      return undefined;
    }
    return this.teamService.findById(teamId);
  },undefined, this.loading);

  navigateToDetail() {
    this.router.navigate(['team', this.team()?.id]);
  }
}
